<style scoped lang="scss">
@import '../mobile';
</style>
<template>
  <div class="wrap-app bg_gray">
    <div class="common-top">
      <img src="@/assets/images/mobile/icon_back.png" class="icon-back" @click="$router.go(-1)">
      <div class="search-box" @click="$router.push('/molecular/search')">
        <input placeholder="请输入订单编号" readonly/>
        <img src="@/assets/images/mobile/icon_search.png" class="icon-search">
      </div>
    </div>
    <ul class="status-tabs">
      <li :class="{active:index === currentTab}" v-for="(item, index) in statusTabs" :key="index" @click="changeTab(index)">{{item}}</li>
    </ul>
    <div class="molecular-lists"
         v-infinite-scroll="loadMore"
         infinite-scroll-disabled="loading"
         infinite-scroll-distance="10"
         immediate-check="false">
      <div class="molecular-item" v-for="(item, index) in orderLists" :key="item.id">
        <div class="top" @click="toDetails(item.id)">
          <div>订单号：<span class="text-primary">{{item.code}}</span></div>
          <span class="status" :class="{'status-danger': item.retainGoods}">{{item.retainGoods ? '部分发货' : '全部已发货'}}</span>
        </div>
        <ul class="products">
          <li v-for="(itx, idx) in item.items" :key="itx.id" v-show="idx < item.showNums">
            <img :src="itx.goods.mainImgUrl" class="pro-img">
            <div class="info">
              <div class="title">
                {{itx.goods.name}}
                <span class="num">x{{itx.needPayQuantity}}</span>
              </div>
              <p class="mt5">货号：{{itx.sku.code}}</p>
              <div class="spec mt5">
                规格：{{itx.sku.spec}}
                <span class="fz14 text-primary" v-if="itx.needSendQuantity === 0">发货完成</span>
                <span class="fz14 text-danger" v-else>剩余数：{{itx.needSendQuantity}}</span>
              </div>
            </div>
          </li>
        </ul>
        <div class="btn-more" @click="bindLoad(index, item.showNums)" v-show="item.items.length > 5 && item.showNums < item.items.length">查看更多</div>
        <div class="bot">
          共{{item.needPayQuantity}}件，应付金额：{{item.amount | amount}}元
          <span>{{item.createTime | rTime}}</span>
        </div>
      </div>
    </div>
    <div class="btn-more" v-show="total !== orderLists.length">加载中</div>
    <div class="btn-more" v-show="total === orderLists.length && orderLists.length > 0">没有更多了</div>
    <div class="no-data" v-show="orderLists.length === 0">暂无相关订单</div>
  </div>
</template>

<script>
import { productOrders } from '@/services/api.index'
export default {
  data () {
    return {
      statusTabs: ['全部订单', '部分发货', '全部发货'],
      currentTab: 0,
      orderLists: [],
      status: '',
      page: 0,
      pageSize: 10,
      total: 0,
      loading: false,
      loaded: false
    }
  },
  created() {
    this.getOrders()
    localStorage.removeItem('searchKeywords')
  },
  methods: {
    changeTab (index) {
      switch (index) {
        case 0:
          this.status = ''
          break
        case 1:
          this.status = 'PART_SEND'
          break
        case 2:
          this.status = 'FINISHED'
          break
      }
      this.currentTab = index
      this.page = 0
      this.orderLists = []
      this.getOrders()
    },
    getOrders () {
      const { page, pageSize, status } = this
      const memberInfo = this.baseMethods.getLocalObj('memberInfo')
      productOrders(page, pageSize, '', '', '', status, memberInfo.id).then(res => {
        res.data.map(item => {
          item.showNums = 5
        })
        this.orderLists = this.orderLists.concat(res.data)
        this.total = this.baseMethods.getTotal(res)
        this.loading = false
        if (this.total === this.orderLists.length) {
          this.loaded = true
        }
      })
    },
    bindLoad (index, nums) {
      this.$set(this.orderLists[index], 'showNums', nums + 5)
    },
    loadMore () {
      if (!this.loaded) {
        this.loading = true
        setTimeout(() => {
          this.page++
          this.getOrders()
        }, 2000)
      }
    },
    // 跳转到详情页
    toDetails (id) {
      this.$router.push(`/molecular/order_details?id=${id}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mobile/molecular/index.vue